import React, { Component, ReactElement } from "react";
import {DurableFunctionInstance, DurableFunctionInstanceHelpers} from "../../models/DurableFunctionInstance";
import { TableRowProps } from "../TableRow";
import Table, { TableColumn } from "../Table";
import TableCell from "../TableCell";
import DurableFunctionInstanceDuration from "../DurableFunctionInstanceDuration";
import MailroomDurableFunctionInstanceStatus from "./MailroomDurableFunctionInstanceStatus";


interface MailroomDurableFunctionInstanceListProps {
    title: string;
    enableRowLinks: boolean;
    instances: DurableFunctionInstance[] | undefined | null;
    columns: TableColumn[];
    additionalCellForColumn?: (item: DurableFunctionInstance, column: TableColumn, columnIndex: number) => ReactElement<TableCell> | undefined;

    linkForInstance?(dfi: DurableFunctionInstance): string;
}

interface MailroomDurableFunctionInstanceListState {
}

export default class MailroomDurableFunctionInstanceList extends Component<MailroomDurableFunctionInstanceListProps, MailroomDurableFunctionInstanceListState>
{
    static genericColumns: TableColumn[] = [
        { title: "Name", propertyPath: "Name", flex: 4, enableSort: true },
        { title: "Created At", propertyPath: "createdAt", enableSort: true, type: "date", flex: 3 },
        { title: "Duration", propertyPath: "duration", flex: 3 },
        { title: "Status", propertyPath: "status", enableSort: true, flex: 2 },
    ];

    static uploadColumns: TableColumn[] = [
        { title: "Name", propertyPath: "Name", flex: 4 },
        { title: "Created At", propertyPath: "createdAt", enableSort: true, type: "date", flex: 3 },
        { title: "Schools", propertyPath: "schools", enableSort: true, type: "date", flex: 2 },
        { title: "Duration", propertyPath: "duration", flex: 3 },
        { title: "Status", propertyPath: "status", enableSort: true, flex: 2 },
    ];

    static processorColumns: TableColumn[] = [
        { title: "Name", propertyPath: "Name", flex: 3 },
        { title: "Created At", propertyPath: "createdAt", enableSort: true, type: "date", flex: 1 },
        { title: "Duration", propertyPath: "duration", flex: 1 },
        { title: "Inbox Upload Metadata", propertyPath: "output.uploadMetadata", flex: 2 },
        { title: "Status", propertyPath: "status", enableSort: true, flex: 2 },
    ];
    
    static processorAdditionalCellForColumn = (item: DurableFunctionInstance, column: TableColumn, columnIndex: number): ReactElement<TableCell> | undefined => {
        
        if(column.propertyPath === "output.uploadMetadata")
        {
            if(item.runtimeStatus === "Completed")
            {
                const output = DurableFunctionInstanceHelpers.ParseOutput(item);
                if(output && output.uploadMetadata)
                {
                    const keys = Object.keys(output.uploadMetadata).filter(key => key !== "$type");
                    const values = keys.map(k => output.uploadMetadata[k]);

                    return (
                      <TableCell key={columnIndex} flex={column.flex}>
                          <div className={"flex-row"}>
                              <div className={"flex-column"}>
                                  {keys.map(k => <span className={"text-extra-detail"}>{k}</span>)}
                              </div>
                              <div className={"flex-column p-left-1rem"}>
                                  {values.map(k => <span>{k}</span>)}
                              </div>
                          </div>
                      </TableCell>
                    );
                }
            }
        }

    }

    public componentDidMount() {

    }

    private rowPropsForInstance = (instance: DurableFunctionInstance): TableRowProps => {
        return {
            to: this.props.linkForInstance ? this.props.linkForInstance(instance) : undefined,
            enableRowLink: this.props.enableRowLinks,
        };
    };

    private cellForColumn = (item: DurableFunctionInstance, column: TableColumn, columnIndex: number): ReactElement<TableCell> | undefined => {
        switch (column.propertyPath) {
            case "Name":
                return <TableCell key={columnIndex} flex={column.flex}>
                    <span>{item.Name}</span>
                    <span className={"cdb-table__extra-detail"}>{item.durableFunctionInstanceId}</span>
                </TableCell>;

            case "schools":
                return <TableCell key={columnIndex} flex={column.flex}>
                    <span>{item.input.schoolCodes?.join(", ")}</span>
                </TableCell>;

            case "status":
                return (
                    <MailroomDurableFunctionInstanceStatus durableFunctionInstance={item} flex={column.flex} />
                );

            case "duration":
                return (
                    <DurableFunctionInstanceDuration durableFunctionInstance={item} flex={column.flex} />
                );

            default:
                if(this.props.additionalCellForColumn)
                {
                    return this.props.additionalCellForColumn(item, column,columnIndex);
                }
                return undefined;
        }
    };

    public render() {

        return (
            <Table
                title={this.props.title}
                items={this.props.instances == undefined ? [] : this.props.instances}
                columns={this.props.columns}
                rowPropsForItem={this.rowPropsForInstance}
                cellForColumn={this.cellForColumn}
                enableSort={true}
                loading={this.props.instances == undefined}
                emptyMessage="No instances found">
                {this.props.children}
            </Table>

        );
    }
}